
import TableList from "@components/templates/tablelist";
import { HttpCostGroupList } from "@/service/boss/cost";
import { mapState, mapGetters } from "vuex";
import comIndex from './update'
export default {
    mixins: [TableList],
    components: {
        comIndex
    },
    data () {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
            erpSkusList: [],
            category: '',
        }
    },
    methods: {
        ajaxRequest: HttpCostGroupList,
        // 全部按钮点击操作
        handleOperates (params = "", type, batch) {
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'costGroupUpdate',
                        params: { type: "add" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: 'costGroupUpdate',
                        params: { type: "edit" },
                        query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: '导入数据',
                        width: 460,
                        showFooter: false,
                        data: { contextId: global.SYSID },
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/serviceSummary/importSummary",
                        name: "excelFile",
                        component: "compUpload",
                        download: this.downloadExcel
                    };
                    break;
                case 'export':
                    if (this.total > 2000) {
                        this.$VMessage.error('导出数据不能大于2000');
                    } else {
                        this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/serviceSummary/export', this.formData, {
                            executor: 'request',
                            download: true,
                        }).catch(err => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                        });
                    }
                    break;

            }
        },
        downloadExcel () {
            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/serviceSummary/summaryTemplate", {}, 'download')
        },
        // 操作下的列表展示内容
        getOperateNodeMap (row) {
            const { id } = row
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: '编辑',
                show: this.handleAuth('erp.costWarehouseGroup.edit'),
                params: id,
                operate: 'edit'
            },]
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewProductList', 'getAllCostGroupName', 'getAllCurrency', 'getNewWarehouseIdList']),
        accountsAll () {
            return this.accounts.sort(function (a, b) {
                return a.flag.localeCompare(b.flag)
            })
        },

        // 左边的批量操作按钮
        ToolsData () {
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "primary",
                },
                // {
                //     name: "查询条件导出",
                //     operate: "import",
                //     theme: "success",
                // }
            ]
        },
        // 搜索下拉框展示内容
        SearchsData () {
            return [
                {
                    label: "成本组名称",
                    tag: 'vInput',
                    key: 'EQ_groupName',
                    show: true,
                },

                {
                    label: "币种",
                    tag: 'vSelect',
                    key: 'EQ_currency',
                    show: true,
                    options: this.getAllCurrency,
                    props: {
                        filterable: true,
                    }
                },

                {
                    label: "仓库名称",
                    tag: 'vSelect',
                    key: 'EQ_orgWarehouseId',
                    show: true,
                    options: this.getNewWarehouseIdList,
                    props: {
                        filterable: true,
                    }
                },

            ]
        },
        // table的展示数据
        columns () {
            return [{
                type: 'selection',
                width: 40,
                align: 'center',
                formName: 'id'
            }, {
                title: '操作',
                width: 70,
                render: this.getOperateNodes
            },
            {
                title: '成本组名称',
                sortable: true,
                render: (h, { row }) => {
                    return <div><a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.groupName}</a></div>
                }
            },
            {
                title: '币种',
                width: 100,
                sortable: true,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.currency}</div>
                    </div>
                }
            },

            {
                title: '包含仓库',
                // key: 'lineId',
                sortable: true,
                render: (h, { row }) => {
                    let arr = []
                    row.warehouseGroupMapEntityList.map(item => {
                        arr.push(item.orgWarehouseCode)
                    })
                    let stringarr = arr.join(",")
                    return <div>
                        <div class="stringware">{stringarr}</div>
                    </div>
                }
            },
            {
                title: '最新更新时间',
                key: 'updatedAt',
                sortable: true
            },
            ];
        },

    },

};
